/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import toast from 'react-hot-toast';

import Btn from '@/components/Btn';
import storage, { storageItem } from '@/utils/storage';

type SecurityCodeProps = {
  onSuccess: () => void;
};

function SecurityCode({ onSuccess }: SecurityCodeProps) {
  const [securityCode, setSecurityCode] = useState(storage.getToken(storageItem.storeSecurityCode) || '');

  const handleSaveSecurityCode = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!securityCode) {
      toast.error('Ingresa un código de seguridad');
      return;
    }
    storage.setToken(storageItem.storeSecurityCode, securityCode);
    toast.success('Código de seguridad guardado');
    onSuccess();
  };

  return (
    <div className="grid max-w-5xl mx-auto bg-white shadow-lg rounded-lg p-4 gap-4">
      <form onSubmit={handleSaveSecurityCode}>
        <div className="mb-4">
          <h2 className="text-2xl">Seguridad:</h2>
          <span className="py-2 text-sm text-gray-700">
            Configura el código de seguridad de tu tienda.
            Este código será solicitado al momento de entrar a la configuración de la tienda.
          </span>
          <div className="relative z-0 w-full my-5 group">
            <input
              type="text"
              name="floating_securityCode"
              id="floating_securityCode"
              className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
              required
              value={securityCode}
              onChange={(e) => setSecurityCode(e.target.value)}
            />
            <label
              htmlFor="floating_securityCode"
              className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Código de seguridad
            </label>
          </div>
        </div>
        <Btn
          type="submit"
          disabled={!securityCode}
        >
          Guardar
        </Btn>
      </form>
    </div>
  );
}

export default SecurityCode;
